export function validatePitstopName(pitstopName) {
	const regex = /^[a-zA-Z0-9\s]+$/;
	return regex.test(pitstopName);
}

export function sanitizePitstopName(pitstopName) {
	return pitstopName
		?.replace(/[^a-zA-Z0-9 ]/g, "")
		.replace(/\s+/g, " ")
		.trim();
}

export function sanitizePitstopUrl(pitstopUrl) {
	return pitstopUrl
		?.toLowerCase()
		.trim()
		.replace(/[^a-zA-Z0-9 ]/g, "")
		.replace(/\s+/g, "-");
}
